import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import image from "../../Assests/Frame 2147225130124.svg";
import containerthree from "../../Assests/trackright/containerthree.svg";

import playstore from "../../Assests/bxl_play-store.svg";
import iapple from "../../Assests/ic_sharp-apple.svg";

const Tymeplusmobile = () => {
  const handlePlayStoreClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.trackrightv2.agentmobileapp",
      "_blank",
    );
  };

  return (
    <>
      <MobileWrap>
        <Container>
          <Row className="pb-5 pt-5 mb-4">
            <Col lg={6} md={12} xs={12}>
              <div className="mobile-img">
                {" "}
                <img src={containerthree} width="70%" />
              </div>
            </Col>
            <Col lg={6} md={12} xs={12}>
              <div className=" py-4 my-4 text-start mobile-contain">
                <h3 style={{ color: "green" }} className="color3 text1 pt-4">
                  TrackRight Mobile App
                </h3>
                <p
                  style={{ fontSize: "19px" }}
                  className="color2 text2 py-4 container_five"
                >
                  Equip your drivers with everything they need to succeed.
                  Drivers can capture digital signatures, take photos of
                  delivered consignments, and scan barcodes directly through the
                  app, with all data syncing to the main office in real-time.
                </p>
                <h2 style={{ color: "green" }} className="color3 text3 mt-4">
                  Download The App Now
                </h2>
                <div className="py-4 d-flex btn-download">
                  {/* <button className="mobile-filldbtn d-flex me-2">
                    <img src={iapple} /> Apple Store
                  </button>{" "} */}
                  <button
                    style={{ backgroundColor: "green" }}
                    className="mobile-filldbtn d-flex me-2"
                    onClick={handlePlayStoreClick}
                  >
                    <img src={playstore} /> Play Store
                  </button>{" "}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </MobileWrap>
    </>
  );
};

export default Tymeplusmobile;

export const MobileWrap = styled.div`
  .container_five {
    font-size: 19px;
  }
  .text1 {
    font-size: 40px;
    font-weight: 700;
  }

  .mobile-img {
    display: flex !important;
    justify-content: center !important;
  }

  .text2 {
    font-size: 16px;
    font-weight: 400;
    padding-right: 22%;
  }

  .text3 {
    font-size: 20px;
    font-weight: 700;
  }

  .mobile-filldbtn {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    background-color: #1f243b;
    border-radius: 10px;
    padding: 8px 24px;
  }

  @media screen and (max-width: 768px) {
    .mobile-img {
      display: flex !important;
      justify-content: center !important;
    }
    .btn-download {
      padding-left: 0rem !important;
      padding-right: 0rem !important;
      text-align: center;
      justify-content: center;
    }

    .mobile-filldbtn {
      padding: 8px 14px !important;
    }

    .mobile-contain {
      padding-left: 0px !important;
      padding-right: 0px !important;
      text-align: center !important;
    }

    .text1 {
      font-size: 20px;
      font-weight: 700;
    }

    .text2 {
      font-size: 16px;
      font-weight: 400;
      padding-right: 5% !important;
      padding-left: 5% !important;
    }
  }
`;
